import { IMAGE_SPECS } from '../constants/status.constant';

export const imageSpecsByModule = (module) => {
    return IMAGE_SPECS[module] || 'Especificaciones desconocidas para este módulo';
};
